import { render, staticRenderFns } from "./RoundedContainer.vue?vue&type=template&id=01224cc4&scoped=true"
import script from "./RoundedContainer.vue?vue&type=script&lang=js"
export * from "./RoundedContainer.vue?vue&type=script&lang=js"
import style0 from "./RoundedContainer.vue?vue&type=style&index=0&id=01224cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01224cc4",
  null
  
)

export default component.exports